// extracted by mini-css-extract-plugin
export default {"form":"profile-form_form__84EEM","buttons":"profile-form_buttons__gfxms","active":"profile-form_active__Iaemg"};